<template>
  <div class="content">
    <base-header class="pb-1">
      <div v-if="editor === 'super-admin' || editor === 'sub-admin'">
        <div class="row">
          <div class="col-md-12">
          </div>
          <div class="col-xl-12">
            <div class="dash-header mb-4">
              <h2 class="text-default m-0 d-flex">Hi, {{ usrname }} <img v-if="!isSafeDig" src="/signup-img/fire.svg" alt="">
              </h2>
              <p class="text-secondary">{{ dashboardWelcomeTagline }}</p>
              <div class="text-right">
                <small>

                  <a @click.prevent="showModal()" class="underline-class" style="cursor: pointer;">
                    Report an Issue?
                  </a>
                </small>
              </div>
            </div>
          </div>
        </div>

        <div class="card top-cardheader">
          <div class="card-header border-bottom px-0 px-sm-4 py-3 d-flex justify-content-between align-items-center">
            <h5 class="font-weight-normal text-default m-0">Employees Overview</h5>
          </div>

          <div class="row m-0">
            <div v-if="canViewCompany" class="col-xl-4 col-md-6 p-0">
              <router-link class="nav-item" to="/all_companies">
                <div class="dash-card-box shadow-none border-right rounded-0 px-3 px-sm-4">
                  <div class="card-value-box">
                    <div class="card-icon-img">
                      <img :src="overviewActiveCompaniesIcon" alt="" />
                    </div>
                    <div class="card-left flex-grow-1 pl-3
                                        ">
                      <h5 class="font-weight-normal m-0" name="Active Users">Active Companies</h5>
                      <span name="Active Users">{{ active_companies }}</span>
                    </div>

                  </div>
                </div>
              </router-link>

            </div>
            <div v-else class="col-xl-4 col-md-6 p-0">
              <div class="dash-card-box shadow-none border-right rounded-0 px-3 px-sm-4">
                <div class="card-value-box">
                  <div class="card-icon-img">
                    <img :src="overviewActiveCompaniesIcon" alt="" />
                  </div>
                  <div class="card-left flex-grow-1 pl-3
                                        ">
                    <h5 class="font-weight-normal m-0" name="Active Users">Active Companies</h5>
                    <span name="Active Users">{{ active_companies }}</span>
                  </div>

                </div>
              </div>
            </div>


            <div v-if="canViewUser" class="col-xl-4 col-md-6 p-0">
              <router-link class="nav-item" to="/all_users">
                <div class="dash-card-box shadow-none border-right rounded-0 px-3 px-sm-4">
                  <div class="card-value-box">
                    <div class="card-icon-img">
                      <img :src="overviewActiveUserIcon" alt="" />
                    </div>
                    <div class="card-left flex-grow-1 pl-3">
                      <h5 class="font-weight-normal m-0" name="Active Courses">Active Users</h5>
                      <span name="Active Courses">{{ active_employees }}</span>
                    </div>

                  </div>
                </div>
              </router-link>
            </div>

            <div v-else class="col-xl-4 col-md-6 p-0">
              <div class="dash-card-box shadow-none border-right rounded-0 px-3 px-sm-4">
                <div class="card-value-box">
                  <div class="card-icon-img">
                    <img :src="overviewActiveUserIcon" alt="" />
                  </div>
                  <div class="card-left flex-grow-1 pl-3">
                    <h5 class="font-weight-normal m-0" name="Active Courses">Active Users</h5>
                    <span name="Active Courses">{{ active_employees }}</span>
                  </div>

                </div>
              </div>
            </div>


            <div v-if="canViewCourse" class="col-xl-4 col-md-6 p-0">
              <router-link to="/courses">
                <div class="dash-card-box shadow-none border-0 rounded-0 px-3 px-sm-4 mb-0">
                  <div class="card-value-box">
                    <div class="card-icon-img">
                      <img :src="overviewActiveCoursesIcon" alt="" />
                    </div>
                    <div class="card-left flex-grow-1 pl-3
                                    ">
                      <h5 class="font-weight-normal m-0">Active Courses</h5>
                      <span>{{ active_courses }}</span>
                    </div>

                  </div>
                </div>
              </router-link>
            </div>

            <div v-else class="col-xl-4 col-md-6 p-0">
              <div class="dash-card-box shadow-none border-0 rounded-0 px-3 px-sm-4 mb-0">
                <div class="card-value-box">
                  <div class="card-icon-img">
                    <img :src="overviewActiveCoursesIcon" alt="" />
                  </div>
                  <div class="card-left flex-grow-1 pl-3
                                    ">
                    <h5 class="font-weight-normal m-0">Active Courses</h5>
                    <span>{{ active_courses }}</span>
                  </div>

                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div v-if="editor === 'company' || editor === 'manager'" class="dashbaord-row-card">
        <div class="row">
          <div class="col-md-12">
          </div>
          <div class="col-md-12">
            <div class="dash-header mb-4">
              <h2 class="text-default m-0 d-flex">Hi, {{ usrname }} <img v-if="!isSafeDig" src="/signup-img/fire.svg" alt="">
              </h2>
              <p class="text-secondary">{{ dashboardWelcomeTagline }}</p>
              <div style="">
                <router-link :to="{ path: '/employee_courses' }" class="d-none d-sm-block">
                  <base-button type="primary" class="font-weight-normal px-4">
                    My Courses
                  </base-button>
                </router-link>
              </div>
              <div class="text-right">
                <small>

                  <a @click.prevent="showModal()" class="underline-class" style="cursor: pointer;">
                    Report an Issue?
                  </a>
                </small>
              </div>
            </div>
          </div>
          <!-- <div class="col-xl-3" v-if="this.freeTrail"> -->
          <div class="col-md-6" v-if="this.freeTrail">
            <div class="dash-header mb-4 text-right">
              <base-button type="primary" class="btn btn-primary ml-3" @click.prevent="cancelTrail()">
                Cancel Trial
              </base-button>
            </div>
          </div>
          <!-- <div class="col-xl-3" > -->
          <div class="col-md-12" v-if="this.freeTrail">
            <div class="dash-header mb-4">
              <div class="alert alert-warning d-flex align-items-center justify-content-between"
                style="background-color: #FEF3E2; color: #FE672C; border: 1px solid #FE672C; border-radius: 5px; padding: 10px;">
                <span style="text-decoration: none;">You are currently using Free Trial</span>
                <base-button class="btn btn-primary ml-3" type="primary" outline="true" @click.prevent="activeTrail()">
                  Start Plan
                </base-button>
              </div>
            </div>
          </div>
        </div>
        <div class="card top-cardheader">
          <div class="card-header border-bottom px-0 px-sm-4 py-3 d-flex justify-content-between align-items-center">
            <h5 class="font-weight-normal text-default m-0">Company Overview</h5>
          </div>
          <div class="row m-0">
            <div class="col-xl-3 col-md-6 p-0">
              <router-link class="nav-item" :to="{
                path: '/company_employees',
                query: adminCompanyId ? { id: adminCompanyId } : {}
              }">
                <div class="dash-card-box shadow-none border-right rounded-0 px-3 px-sm-4 h-100">
                  <div class="card-value-box">
                    <div class="card-icon-img">
                      <img :src="overviewDashUserIcon" />
                    </div>
                    <div class="card-left flex-grow-1 pl-3
                                        ">
                      <h5 class="font-weight-normal m-0" name="Active Users">Active Users</h5>
                      <span name="Active Users">{{ active_employees }}</span>
                    </div>

                  </div>
                </div>
              </router-link>
            </div>
            <div class="col-xl-3 col-md-6 p-0">
              <div
                class="dash-card-box shadow-none border-right rounded-0 pl-3 pl-sm-4 pr-lg-0 h-100 position-relative">
                <div class="card-value-box">
                  <router-link class="nav-item" to="/company_locations">
                    <div class="card-icon-img">
                      <img :src="overviewDashLocationIcon" />
                    </div>
                  </router-link>
                  <div class="card-left flex-grow-1 d-flex pl-3 justify-content-between align-items-start">
                    <router-link class="nav-item" to="/company_locations">
                      <div>
                        <h5 class="font-weight-normal m-0" name="Active Locations">Locations</h5>
                        <span name="Active Courses">{{ active_location }}</span>
                      </div>
                    </router-link>
                    <div class="location_FlexBox ml-2">
                      <div class="select_new company-location-dropdown " style="color:white;">
                        <el-select name="Employee Location Filter" class="select-primary max-width location_dropdown"
                          :class="brand.primary ? 'select-brand' : 'select-primary-orange'"
                          popper-class="custom-dropdown-style" v-model="adminCompanyId"
                          placeholder="Filter by Location">
                          <el-option class="select-default" v-for="item in companyAdminlocations" :key="item.value"
                            :label="item.label" :value="item.value" />
                        </el-select>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <div class="col-xl-3 col-md-6 p-0">
              <router-link class="nav-item" to="/company_courses">
                <div class="dash-card-box shadow-none border-right rounded-0 px-3 px-sm-4 h-100">
                  <div class="card-value-box">
                    <div class="card-icon-img">
                      <img :src="overviewDashCoursesIcon" />
                    </div>
                    <div class="card-left flex-grow-1 pl-3">
                      <h5 class="font-weight-normal m-0" name="Active Courses">Total Courses</h5>
                      <span name="Active Courses">{{ active_courses }}</span>
                    </div>

                  </div>
                </div>
              </router-link>
            </div>
            <div class="col-xl-3 col-md-6 p-0">
              <router-link to="/company_certificates">
                <div class="dash-card-box shadow-none border-0 rounded-0 px-3 px-sm-4 mb-0 h-100">
                  <div class="card-value-box">
                    <div class="card-icon-img">
                      <img :src="overviewDashCertificateIcon" />
                    </div>
                    <div class="card-left flex-grow-1 pl-3
                                    ">
                      <h5 class="font-weight-normal m-0">Certificates</h5>
                      <span>{{ total_cer }}</span>
                    </div>

                  </div>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <div v-if="editor === 'employee'" class="dashbaord-row-card">
        <div class="row">
          <div class="col-md-12">
          </div>
          <div class="col-xl-12">
            <div class="dash-header mb-4">
              <h2 class="text-default m-0 d-flex">Hi, {{ usrname }} <img v-if="!isSafeDig" src="/signup-img/fire.svg" alt="">
              </h2>
              <p class="text-secondary">{{ dashboardWelcomeTagline }}</p>
              <router-link :to="{ path: '/employee_courses' }" class="d-none d-sm-block">
                <base-button type="primary" class="font-weight-normal px-4">
                  My Courses
                </base-button>
              </router-link>
              <div class="text-right ">
                <small>
                  <a @click.prevent="showModal()" class="underline-class" style="cursor: pointer;">
                    Report an Issue?
                  </a>
                </small>
              </div>
            </div>
          </div>
        </div>
        <div class="card top-cardheader">
          <div class="card-header border-bottom px-0 px-sm-4 py-3 d-flex justify-content-between align-items-center">
            <h5 class="font-weight-normal text-default m-0">Course Overview</h5>
          </div>
          <div class="row m-0">
            <div class="col-xl-3 col-md-6 p-0">
              <router-link class="nav-item" to="/employee_courses?course=open">
                <div v-if="opened != '0'"
                  class="dash-card-box emp-card-box shadow-none border-right rounded-0 px-3 px-sm-4">
                  <div class="card-value-box">
                    <div class="card-icon-img">
                      <img :src="courseStatusIcons.open" />
                    </div>
                    <div class="card-left flex-grow-1 pl-3">
                      <h5 class="font-weight-normal m-0" name="Active Users">Open Courses</h5>
                      <span name="Active Users">{{tableData.filter((data) => data.course_status === 2).length}}</span>
                    </div>
                  </div>
                </div>
                <div v-else class="dash-card-box emp-card-box shadow-none border-right rounded-0 px-3 px-sm-4">
                  <div class="card-value-box">
                    <div class="card-icon-img">
                      <img :src="courseStatusIcons.open" />
                    </div>
                    <div class="card-left flex-grow-1 pl-3">
                      <h5 class="font-weight-normal m-0" name="Active Users">Open Courses</h5>
                      <span name="Active Users">0</span>
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
            <div class="col-xl-3 col-md-6 p-0">
              <router-link class="nav-item" to="/employee_courses?course=passed">
                <div v-if="passed != '0'"
                  class="dash-card-box emp-card-box shadow-none border-right rounded-0 px-3 px-sm-4">
                  <div class="card-value-box">
                    <div class="card-icon-img">
                      <img :src="courseStatusIcons.passed" />
                    </div>
                    <div class="card-left flex-grow-1 pl-3">
                      <h5 class="font-weight-normal m-0" name="Active Users">Passed Courses</h5>
                      <span name="Active Users">{{ passed }}</span>
                    </div>
                  </div>
                </div>
                <div v-else class="dash-card-box emp-card-box shadow-none border-right rounded-0 px-3 px-sm-4">
                  <div class="card-value-box">
                    <div class="card-icon-img">
                      <img :src="courseStatusIcons.passed" />
                    </div>
                    <div class="card-left flex-grow-1 pl-3
                                        ">
                      <h5 class="font-weight-normal m-0" name="Active Users">Passed Courses</h5>
                      <span name="Active Users">0</span>
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
            <div class="col-xl-3 col-md-6 p-0">
              <router-link class="nav-item" to="/employee_courses?course=failed">
                <div v-if="failed != '0'"
                  class="dash-card-box emp-card-box shadow-none border-right rounded-0 px-3 px-sm-4">
                  <div class="card-value-box">
                    <div class="card-icon-img">
                      <img :src="courseStatusIcons.failed" />
                    </div>
                    <div class="card-left flex-grow-1 pl-3
                                        ">
                      <h5 class="font-weight-normal m-0" name="Active Users">Failed Courses</h5>
                      <span name="Active Users">{{tableData.filter((data) => data.course_status === 0).length}}</span>
                    </div>
                  </div>
                </div>
                <div v-else class="dash-card-box emp-card-box shadow-none border-right rounded-0 px-3 px-sm-4">
                  <div class="card-value-box">
                    <div class="card-icon-img">
                      <img :src="courseStatusIcons.failed" />
                    </div>
                    <div class="card-left flex-grow-1 pl-3
                                        ">
                      <h5 class="font-weight-normal m-0" name="Active Users">Failed Courses</h5>
                      <span name="Active Users">0</span>
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
            <div class="col-xl-3 col-md-6 p-0">
              <router-link class="nav-item" to="/employee_courses?course=expired">
                <div v-if="expired != '0'"
                  class="dash-card-box emp-card-box shadow-none border-right rounded-0 px-3 px-sm-4">
                  <div class="card-value-box">
                    <div class="card-icon-img">
                      <img :src="courseStatusIcons.expired" />
                    </div>
                    <div class="card-left flex-grow-1 pl-3
                                        ">
                      <h5 class="font-weight-normal m-0" name="Active Users">Overdue Courses</h5>
                      <span name="Active Users">{{tableData.filter((data) => data.course_status === 3).length}}</span>
                    </div>
                  </div>
                </div>
                <div v-else class="dash-card-box emp-card-box shadow-none border-right rounded-0 px-3 px-sm-4">
                  <div class="card-value-box">
                    <div class="card-icon-img">
                      <img :src="courseStatusIcons.expired" />
                    </div>
                    <div class="card-left flex-grow-1 pl-3
                                        ">
                      <h5 class="font-weight-normal m-0" name="Active Users">Overdue Courses</h5>
                      <span name="Active Users">0</span>
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </base-header>
    <div class="data-wrap">
      <div v-if="editor === 'super-admin' || editor === 'sub-admin'" id="client-section">
        <companies companyHeading="Companies" v-if="canViewCompany"></companies>
      </div>
      <div v-if="editor === 'company' || editor === 'manager'" id="non-complaint">
        <div class="row dash_list mb-4">
          <div class="col-xl-8 mb-4 mb-xl-0">
            <template>
              <div class="card dashbarod-table-box mb-0 h-100">
                <completions-graph :company_id="adminCompanyId"></completions-graph>
              </div>
            </template>
          </div>
          <div class="col-xl-4">
            <template>
              <div class="card dashbarod-table-box mb-0 h-100">
                <pof-pie-chart :company_id="adminCompanyId"></pof-pie-chart>
              </div>
            </template>
          </div>


        </div>
        <div class="row">
          <div class="col-12 col-lg-6">
            <card body-classes="" class="no-border-card table-card-header card-height card-with-table"
              footer-classes="pb-2">
              <template slot="header">
                <div class="row align-items-center justify-content-between home-card-header">
                  <div class="col-12 col-sm-auto">
                    <h5 class="mb-0 d-flex">Courses Due In Next 7 Days</h5>
                  </div>
                  <div class="col-auto mt-2 mt-lg-0 text-left text-lg-right justify-content-end">
                    <base-button v-intro="'Click this button to send a mass email to all non-compliant users.'"
                      v-intro-step="3" type="primary" outline="true" class="fire-btn" name="Remind Entire List"
                      v-on:click="sendReminderAllEmployees('due')">Remind Entire
                      List
                      <svg v-if="isSafeDig" class="safedig-envelope-icon" width="24" height="24" viewBox="0 0 24 24"
                        fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                        <path
                          d="M4 6.75C4 5.7835 4.7835 5 5.75 5H18.25C19.2165 5 20 5.7835 20 6.75V17.25C20 18.2165 19.2165 19 18.25 19H5.75C4.7835 19 4 18.2165 4 17.25V6.75ZM6 7.2V7.5L12 11.75L18 7.5V7.2C18 7.08954 17.9105 7 17.8 7H6.2C6.08954 7 6 7.08954 6 7.2ZM18 9.95L12.5798 13.7899C12.2331 14.0354 11.7669 14.0354 11.4202 13.7899L6 9.95V16.8C6 16.9105 6.08954 17 6.2 17H17.8C17.9105 17 18 16.9105 18 16.8V9.95Z"
                          fill="#3E7799" />
                      </svg>
                      <svg v-else width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M14.7166 9.33333C14.525 9.08333 14.2916 8.86667 14.075 8.65C13.5166 8.15 12.8833 7.79167 12.35 7.26667C11.1083 6.05 10.8333 4.04167 11.625 2.5C10.8333 2.69167 10.1416 3.125 9.54998 3.6C7.39165 5.33333 6.54165 8.39167 7.55831 11.0167C7.59165 11.1 7.62498 11.1833 7.62498 11.2917C7.62498 11.475 7.49998 11.6417 7.33331 11.7083C7.14165 11.7917 6.94165 11.7417 6.78331 11.6083C6.73602 11.5687 6.69646 11.5207 6.66665 11.4667C5.72498 10.275 5.57498 8.56667 6.20831 7.2C4.81665 8.33333 4.05831 10.25 4.16665 12.0583C4.21665 12.475 4.26665 12.8917 4.40831 13.3083C4.52498 13.8083 4.74998 14.3083 4.99998 14.75C5.89998 16.1917 7.45831 17.225 9.13331 17.4333C10.9166 17.6583 12.825 17.3333 14.1916 16.1C15.7166 14.7167 16.25 12.5 15.4666 10.6L15.3583 10.3833C15.1833 10 14.7166 9.33333 14.7166 9.33333ZM12.0833 14.5833C11.85 14.7833 11.4666 15 11.1666 15.0833C10.2333 15.4167 9.29998 14.95 8.74998 14.4C9.74165 14.1667 10.3333 13.4333 10.5083 12.6917C10.65 12.025 10.3833 11.475 10.275 10.8333C10.175 10.2167 10.1916 9.69167 10.4166 9.11667C10.575 9.43333 10.7416 9.75 10.9416 10C11.5833 10.8333 12.5916 11.2 12.8083 12.3333C12.8416 12.45 12.8583 12.5667 12.8583 12.6917C12.8833 13.375 12.5833 14.125 12.0833 14.5833Z"
                          fill="#FE672C" />
                      </svg>
                    </base-button>
                  </div>
                </div>
              </template>
              <div>
                <div class="user-eltable table-style-normal">
                  <el-table :data="tbl_data" class="dueGrid" header-row-class-name="thead-light custom-thead-light"
                    role="table">
                    <el-table-column label="Full Name" prop="name" min-width="75" class-name="ignore-translation">
                      <template slot-scope="props">
                        <span>{{ props.row.first_name + " " + props.row.last_name }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="Location" min-width="75" prop="company" class="blue">
                      <template slot-scope="props" class="red">
                        <span>{{ props.row.company }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="" min-width="76">
                      <template slot="header">
                        <el-popover ref="fromPopOver" placement="top-start" trigger="hover" width="250">
                          <span> P = Passed. This user is compliant.<br /><br />O = Open. This
                            user
                            has open courses,but is also compliant.<br /><br />F = Failed.
                            This user
                            is non-compliant because they did not pass the assigned course
                            in the
                            time permitted. </span>
                        </el-popover>
                        <span>P/O/F
                          <i v-popover:fromPopOver class="el-icon-question text-blue" />
                        </span>
                      </template>
                      <template slot-scope="props">
                        <span v-on:click="openCourseDetailsDue(props.row, val = true)">
                          <base-button v-if="props.row.fail != '0'" class="POF_btn" type=" pof-value pofcolorfail">{{
                            props.row.pof
                          }}</base-button>
                          <base-button v-else-if="props.row.open != '0'" class="POF_btn"
                            type=" pof-value pofcoloropen">{{ props.row.pof }}</base-button>
                          <base-button v-else-if="props.row.pass != '0'" class="POF_btn"
                            type=" pof-value pofcolorpass">{{ props.row.pof }}</base-button>
                          <base-button v-else class="POF_btn" type="default">{{
                            props.row.pof
                          }}</base-button>
                        </span>
                      </template>
                    </el-table-column>
                    <el-table-column class-name="action-last" align="left" label="Action" min-width="53">
                      <div slot-scope="{ $index, row }" class="d-flex">
                        <base-button class="edit p-0 bg-transparent border-0 shadow-none" icon name="Send Reminder"
                          size="sm" type="success" @click="sendExpiringReminder($index, row)">
                          <svg width="27" height="27" viewBox="0 0 27 27" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <circle cx="13.5" cy="13.5" r="13.5" fill="#E7E7E7" />
                            <path
                              d="M17.25 12.25C17.25 10.1789 15.5711 8.5 13.5 8.5C11.4289 8.5 9.75 10.1789 9.75 12.25V17.25H17.25V12.25ZM18.5 17.6667L18.75 18C18.8536 18.1381 18.8256 18.3339 18.6875 18.4375C18.6334 18.4781 18.5676 18.5 18.5 18.5H8.5C8.32741 18.5 8.1875 18.3601 8.1875 18.1875C8.1875 18.1199 8.20943 18.0541 8.25 18L8.5 17.6667V12.25C8.5 9.48857 10.7386 7.25 13.5 7.25C16.2614 7.25 18.5 9.48857 18.5 12.25V17.6667ZM11.9375 19.125H15.0625C15.0625 19.9879 14.3629 20.6875 13.5 20.6875C12.6371 20.6875 11.9375 19.9879 11.9375 19.125Z"
                              fill="#737373" />
                          </svg>
                        </base-button>
                      </div>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
              <div class="pagination-wrap mt-4 mb-3 d-flex justify-content-end px-4" v-if="tbl_data.length > 0">
                <nav>
                  <ul class="pagination custom-pagination">
                    <li class="page-item" :class="{ disabled: coursesDuePagination.current_page === 1 }">
                      <a class="page-link" href="#"
                        @click.prevent="changeCoursesDuePage(coursesDuePagination.current_page - 1)">
                        <span>
                          <svg width="7" height="15" viewBox="0 0 7 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M6.68912 0.384851C6.78767 0.506051 6.86585 0.650013 6.9192 0.808497C6.97254 0.966982 7 1.13688 7 1.30845C7 1.48003 6.97254 1.64993 6.9192 1.80841C6.86585 1.96689 6.78767 2.11086 6.68912 2.23206L2.56453 7.31515L6.68912 12.3982C6.88788 12.6432 6.99955 12.9754 6.99955 13.3218C6.99955 13.6683 6.88788 14.0005 6.68912 14.2455C6.49036 14.4904 6.22077 14.628 5.93968 14.628C5.65858 14.628 5.389 14.4904 5.19023 14.2455L0.310879 8.2322C0.212332 8.111 0.134148 7.96704 0.0808029 7.80856C0.0274577 7.65007 4.76837e-07 7.48018 4.76837e-07 7.3086C4.76837e-07 7.13702 0.0274577 6.96713 0.0808029 6.80864C0.134148 6.65016 0.212332 6.5062 0.310879 6.385L5.19023 0.37175C5.59419 -0.126079 6.27453 -0.126079 6.68912 0.384851Z"
                              fill="#A9A9A9" fill-opacity="0.73" />
                          </svg>
                        </span>
                      </a>
                    </li>
                    <li v-for="page in getCoursesDuePageNumbers" :key="page" class="page-item"
                      :class="{ active: coursesDuePagination.current_page === page }">
                      <a class="page-link" href="#" @click.prevent="changeCoursesDuePage(page)">{{ page }}</a>
                    </li>
                    <li class="page-item"
                      :class="{ disabled: coursesDuePagination.current_page === coursesDuePagination.last_page }">
                      <a class="page-link" href="#"
                        @click.prevent="changeCoursesDuePage(coursesDuePagination.current_page + 1)">
                        <span>
                          <svg width="7" height="15" viewBox="0 0 7 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M0.31088 0.384851C0.212332 0.506051 0.134148 0.650013 0.0808034 0.808497C0.0274585 0.966982 0 1.13688 0 1.30845C0 1.48003 0.0274585 1.64993 0.0808034 1.80841C0.134148 1.96689 0.212332 2.11086 0.31088 2.23206L4.43547 7.31515L0.31088 12.3982C0.112115 12.6432 0.000450125 12.9754 0.000450125 13.3218C0.000450125 13.6683 0.112115 14.0005 0.31088 14.2455C0.509645 14.4904 0.779227 14.628 1.06032 14.628C1.34142 14.628 1.611 14.4904 1.80977 14.2455L6.68912 8.2322C6.78767 8.111 6.86585 7.96704 6.9192 7.80856C6.97254 7.65007 7 7.48018 7 7.3086C7 7.13702 6.97254 6.96713 6.9192 6.80864C6.86585 6.65016 6.78767 6.5062 6.68912 6.385L1.80977 0.37175C1.40581 -0.126079 0.725466 -0.126079 0.31088 0.384851Z"
                              fill="#A9A9A9" fill-opacity="0.73" />
                          </svg>
                        </span>
                      </a>
                    </li>
                  </ul>
                </nav>
              </div>

            </card>
          </div>
          <div class="col-12 col-lg-6">
            <card id="non-comp-section" body-classes=""
              class="no-border-card table-card-header card-height card-with-table" footer-classes="pb-2">
              <template slot="header">
                <div class="row align-items-center justify-content-between home-card-header">
                  <div class="col-12 col-sm-auto">
                    <h5 v-intro="'Here you will find a list of all employees who are not compliant with training.'"
                      v-intro-step="2" class="mb-0 d-flex">Non-Compliant Employees
                    </h5>
                  </div>
                  <!-- {{ queriedData }}  -->
                  <!-- <div v-if="queriedData != 0" class="col-md-8 text-right"> -->
                  <div class="col-auto mt-2 mt-lg-0 text-left text-lg-right justify-content-end">
                    <base-button v-intro="'Click this button to send a mass email to all non-compliant users.'"
                      v-intro-step="3" type="primary" outline="true" class="fire-btn" name="Remind Entire List"
                      v-on:click="sendReminderAllEmployees('non_compliant')">Remind Entire
                      List
                      <svg v-if="isSafeDig" class="safedig-envelope-icon" width="24" height="24" viewBox="0 0 24 24"
                        fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                        <path
                          d="M4 6.75C4 5.7835 4.7835 5 5.75 5H18.25C19.2165 5 20 5.7835 20 6.75V17.25C20 18.2165 19.2165 19 18.25 19H5.75C4.7835 19 4 18.2165 4 17.25V6.75ZM6 7.2V7.5L12 11.75L18 7.5V7.2C18 7.08954 17.9105 7 17.8 7H6.2C6.08954 7 6 7.08954 6 7.2ZM18 9.95L12.5798 13.7899C12.2331 14.0354 11.7669 14.0354 11.4202 13.7899L6 9.95V16.8C6 16.9105 6.08954 17 6.2 17H17.8C17.9105 17 18 16.9105 18 16.8V9.95Z"
                          fill="#3E7799" />
                      </svg>
                      <svg v-else width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M14.7166 9.33333C14.525 9.08333 14.2916 8.86667 14.075 8.65C13.5166 8.15 12.8833 7.79167 12.35 7.26667C11.1083 6.05 10.8333 4.04167 11.625 2.5C10.8333 2.69167 10.1416 3.125 9.54998 3.6C7.39165 5.33333 6.54165 8.39167 7.55831 11.0167C7.59165 11.1 7.62498 11.1833 7.62498 11.2917C7.62498 11.475 7.49998 11.6417 7.33331 11.7083C7.14165 11.7917 6.94165 11.7417 6.78331 11.6083C6.73602 11.5687 6.69646 11.5207 6.66665 11.4667C5.72498 10.275 5.57498 8.56667 6.20831 7.2C4.81665 8.33333 4.05831 10.25 4.16665 12.0583C4.21665 12.475 4.26665 12.8917 4.40831 13.3083C4.52498 13.8083 4.74998 14.3083 4.99998 14.75C5.89998 16.1917 7.45831 17.225 9.13331 17.4333C10.9166 17.6583 12.825 17.3333 14.1916 16.1C15.7166 14.7167 16.25 12.5 15.4666 10.6L15.3583 10.3833C15.1833 10 14.7166 9.33333 14.7166 9.33333ZM12.0833 14.5833C11.85 14.7833 11.4666 15 11.1666 15.0833C10.2333 15.4167 9.29998 14.95 8.74998 14.4C9.74165 14.1667 10.3333 13.4333 10.5083 12.6917C10.65 12.025 10.3833 11.475 10.275 10.8333C10.175 10.2167 10.1916 9.69167 10.4166 9.11667C10.575 9.43333 10.7416 9.75 10.9416 10C11.5833 10.8333 12.5916 11.2 12.8083 12.3333C12.8416 12.45 12.8583 12.5667 12.8583 12.6917C12.8833 13.375 12.5833 14.125 12.0833 14.5833Z"
                          fill="#FE672C" />
                      </svg>
                    </base-button>
                  </div>
                </div>
              </template>
              <div>
                <div class="user-eltable table-style-normal">
                  <!-- <el-table :data="tbl_data" class="nonGrid" -->
                  <el-table :data="tableData" class="nonGrid" header-row-class-name="thead-light custom-thead-light"
                    role="table" row-key="id" @sort-change="sortChange" @selection-change="selectionChange">
                    <el-table-column label="Full Name" prop="name" min-width="75" class-name="ignore-translation">
                      <template slot-scope="props">
                        <span>{{ props.row.first_name + " " + props.row.last_name }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="Location" prop="company" min-width="75" class-name="ignore-translation">
                      <template slot-scope="props">
                        <span>{{ props.row.company }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="" min-width="76">
                      <template slot="header">
                        <el-popover ref="fromPopOver" placement="top-start" trigger="hover" width="250">
                          <span> P = Passed. This user is compliant.<br /><br />O = Open. This
                            user
                            has open courses,but is also compliant.<br /><br />F = Failed.
                            This user
                            is non-compliant because they did not pass the assigned course
                            in the
                            time permitted. </span>
                        </el-popover>
                        <span>P/O/F
                          <i v-popover:fromPopOver class="el-icon-question text-blue" />
                        </span>
                      </template>
                      <template slot-scope="props">
                        <span v-on:click="openCourseDetailsDue(props.row)">
                          <base-button v-if="props.row.fail != '0'" class="POF_btn" type=" pof-value pofcolorfail">{{
                            props.row.pof
                          }}</base-button>
                          <base-button v-else-if="props.row.open != '0'" class="POF_btn"
                            type=" pof-value pofcoloropen">{{ props.row.pof }}</base-button>
                          <base-button v-else-if="props.row.pass != '0'" class="POF_btn"
                            type=" pof-value pofcolorpass">{{ props.row.pof }}</base-button>
                          <base-button v-else class="POF_btn" type="default">{{
                            props.row.pof
                          }}</base-button>
                        </span>
                      </template>
                    </el-table-column>
                    <el-table-column align="left" label="Action" min-width="53">
                      <div slot-scope="{ $index, row }" class="d-flex">
                        <base-button class="edit p-0 bg-transparent border-0 shadow-none" icon name="Send Reminder"
                          size="sm" type="success" @click="sendReminder($index, row)">
                          <svg width="27" height="27" viewBox="0 0 27 27" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <circle cx="13.5" cy="13.5" r="13.5" fill="#E7E7E7" />
                            <path
                              d="M17.25 12.25C17.25 10.1789 15.5711 8.5 13.5 8.5C11.4289 8.5 9.75 10.1789 9.75 12.25V17.25H17.25V12.25ZM18.5 17.6667L18.75 18C18.8536 18.1381 18.8256 18.3339 18.6875 18.4375C18.6334 18.4781 18.5676 18.5 18.5 18.5H8.5C8.32741 18.5 8.1875 18.3601 8.1875 18.1875C8.1875 18.1199 8.20943 18.0541 8.25 18L8.5 17.6667V12.25C8.5 9.48857 10.7386 7.25 13.5 7.25C16.2614 7.25 18.5 9.48857 18.5 12.25V17.6667ZM11.9375 19.125H15.0625C15.0625 19.9879 14.3629 20.6875 13.5 20.6875C12.6371 20.6875 11.9375 19.9879 11.9375 19.125Z"
                              fill="#737373" />
                          </svg>
                        </base-button>
                      </div>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
              <div class="pagination-wrap mt-4 mb-3 d-flex justify-content-end px-4" v-if="tableData.length > 0">
                <nav>
                  <ul class="pagination custom-pagination">
                    <li class="page-item" :class="{ disabled: nonCompliancePagination.current_page === 1 }">
                      <a class="page-link" href="#"
                        @click.prevent="changeNonCompliancePage(nonCompliancePagination.current_page - 1)">
                        <span>
                          <svg width="7" height="15" viewBox="0 0 7 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M6.68912 0.384851C6.78767 0.506051 6.86585 0.650013 6.9192 0.808497C6.97254 0.966982 7 1.13688 7 1.30845C7 1.48003 6.97254 1.64993 6.9192 1.80841C6.86585 1.96689 6.78767 2.11086 6.68912 2.23206L2.56453 7.31515L6.68912 12.3982C6.88788 12.6432 6.99955 12.9754 6.99955 13.3218C6.99955 13.6683 6.88788 14.0005 6.68912 14.2455C6.49036 14.4904 6.22077 14.628 5.93968 14.628C5.65858 14.628 5.389 14.4904 5.19023 14.2455L0.310879 8.2322C0.212332 8.111 0.134148 7.96704 0.0808029 7.80856C0.0274577 7.65007 4.76837e-07 7.48018 4.76837e-07 7.3086C4.76837e-07 7.13702 0.0274577 6.96713 0.0808029 6.80864C0.134148 6.65016 0.212332 6.5062 0.310879 6.385L5.19023 0.37175C5.59419 -0.126079 6.27453 -0.126079 6.68912 0.384851Z"
                              fill="#A9A9A9" fill-opacity="0.73" />
                          </svg>
                        </span>
                      </a>
                    </li>
                    <li v-for="page in getNonCompliancePageNumbers" :key="page" class="page-item"
                      :class="{ active: nonCompliancePagination.current_page === page }">
                      <a class="page-link" href="#" @click.prevent="changeNonCompliancePage(page)">{{ page }}</a>
                    </li>
                    <li class="page-item"
                      :class="{ disabled: nonCompliancePagination.current_page === nonCompliancePagination.last_page }">
                      <a class="page-link" href="#"
                        @click.prevent="changeNonCompliancePage(nonCompliancePagination.current_page + 1)">
                        <span>
                          <svg width="7" height="15" viewBox="0 0 7 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M0.31088 0.384851C0.212332 0.506051 0.134148 0.650013 0.0808034 0.808497C0.0274585 0.966982 0 1.13688 0 1.30845C0 1.48003 0.0274585 1.64993 0.0808034 1.80841C0.134148 1.96689 0.212332 2.11086 0.31088 2.23206L4.43547 7.31515L0.31088 12.3982C0.112115 12.6432 0.000450125 12.9754 0.000450125 13.3218C0.000450125 13.6683 0.112115 14.0005 0.31088 14.2455C0.509645 14.4904 0.779227 14.628 1.06032 14.628C1.34142 14.628 1.611 14.4904 1.80977 14.2455L6.68912 8.2322C6.78767 8.111 6.86585 7.96704 6.9192 7.80856C6.97254 7.65007 7 7.48018 7 7.3086C7 7.13702 6.97254 6.96713 6.9192 6.80864C6.86585 6.65016 6.78767 6.5062 6.68912 6.385L1.80977 0.37175C1.40581 -0.126079 0.725466 -0.126079 0.31088 0.384851Z"
                              fill="#A9A9A9" fill-opacity="0.73" />
                          </svg>
                        </span>
                      </a>
                    </li>
                  </ul>
                </nav>
              </div>

            </card>

          </div>

        </div>
        <!-- <most-recent-completions :company_id="adminCompanyId"></most-recent-completions> -->
      </div>
      <div v-if="editor === 'employee'">
        <div v-if="folderProgress.length > 0" class="row">
          <div class="col-xl-12">
            <div class="card dashbarod-table-box">
              <div class="graph-title">
                <h3
                  v-intro="'This section tells you how many courses you have in your program.  The chart shows your progress completing those courses.'"
                  v-intro-step="2">Course Folder Progress</h3>
              </div>
              <div class="row">
                <div v-for="(data, index) in folderProgress" v-bind:key="index"
                  :class="folderProgress.length == 3 ? 'col-md-4' : folderProgress.length == 2 ? 'col-md-6' : folderProgress.length == 1 ? 'col-md-12' : ''">
                  <folder-progress-graph :failed_count="data.failed_course_count" :folder_name="data.folder_name"
                    :passed_count="data.passed_course_count" :total_count="data.course_count"></folder-progress-graph>
                </div>
              </div>
            </div>
          </div>
        </div>
        <card class="no-border-card courses employee-content-wrap" footer-classes="pb-2" style="margin-top: 20px">
          <template slot="header">
            <div class="row" style="padding-bottom: 0px !important">
              <div class="col-md-3">
                <h2
                  v-intro="'These are the courses you are required to take.  If any courses are Overdue, you should complete them first, then complete the Open courses.  If there are no courses listed, you are up to date with your training.'"
                  v-intro-step="1">Required Courses</h2>
              </div>
              <div class="col-md-9"></div>
            </div>
          </template>
          <div>
            <span v-if="tableData.length > 0">
              <div class="grid-action-boxes">
                <div class="row">
                  <div class="col-md-4 mb-4" v-for="course in tableData" :key="course.id">
                    <span v-if="tableData.filter(data => data.course_status === 2).length > 0">
                      <div class="grid-wrap border rounded p-3">
                        <span class="img-wrap position-relative">
                          <img class="d-block mx-auto w-100 mb-3" :src="course.img ? course.img : '/placeholder.jpg'"
                            style="height: 200px; object-fit: cover;">
                          <a class="play-btn" href="#" v-if="is_payByEmployeeOn && !course.is_employee_paid"
                            @click.prevent="PayCourse(course)">
                            <img :src="playIcon" alt="">
                          </a>
                          <a class="play-btn" href="#" v-else @click.prevent="
                            takingCourse(
                              course.id,
                              course.due_date,
                              course.is_2fa_required
                            )">
                            <img :src="playIcon" alt="">
                          </a>
                        </span>
                        <div class="grid-header d-flex justify-content-between">
                          <h5 class="mb-4">{{ course.course_name }}</h5>
                        </div>
                        <div class="course-status mb-4">
                          <span class="failed" v-if="course.course_status == '2'">Open</span>
                          <span class="expired" v-if="course.course_status == '0'">Failed</span>
                          <span class="expired" v-if="course.course_status == '3'">Expired</span>
                        </div>
                        <div class="progress-area mb-4">
                          <div class="progress-top-row d-flex justify-content-between">
                            <span class="assigned">Due Date : {{ course.due_date }}</span>
                            <span class="time">
                              <svg width="15" height="15" viewBox="0 0 15 15" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                  d="M7.50001 14.5832C3.58799 14.5832 0.416672 11.4118 0.416672 7.49984C0.416672 3.58782 3.58799 0.416504 7.50001 0.416504C11.412 0.416504 14.5833 3.58782 14.5833 7.49984C14.5833 11.4118 11.412 14.5832 7.50001 14.5832ZM7.50001 13.1665C10.6296 13.1665 13.1667 10.6295 13.1667 7.49984C13.1667 4.37022 10.6296 1.83317 7.50001 1.83317C4.37039 1.83317 1.83334 4.37022 1.83334 7.49984C1.83334 10.6295 4.37039 13.1665 7.50001 13.1665ZM8.20834 7.49984H11.0417V8.9165H6.79167V3.95817H8.20834V7.49984Z"
                                  fill="#787878" />
                              </svg>

                              {{ course.course_length }} minutes
                            </span>
                          </div>

                        </div>
                        <div class="action-area d-flex justify-content-between">
                          <base-button name="Pay Course" class="px-3 py-2 w-100"
                            v-if="is_payByEmployeeOn && !course.is_employee_paid" @click.prevent="PayCourse(course)"
                            type="primary" outline="true">

                            {{ "Pay" }}
                          </base-button>
                          <base-button type="primary" outline="true" class="px-3 py-2 w-100" name="Take Course" v-else
                            @click.prevent="
                              takingCourse(
                                course.id,
                                course.due_date,
                                course.is_2fa_required
                              )
                              ">

                            {{
                              course.course_attempts !== undefined &&
                                course.course_attempts.length > 0
                                ? "Retake Course "
                                : "Take Course"
                            }}
                          </base-button>
                        </div>
                      </div>
                    </span>
                  </div>
                </div>
              </div>
            </span>
            <span v-else>
              <div class="grid-wrap border rounded p-3">
                <img :src="emptySlotIcon" alt="No data available" class="w-100"
                  style="max-width: 300px; margin: 0 auto; display: block;">
              </div>
            </span>
          </div>
        </card>
      </div>
    </div>
    <modal :show.sync="employeeDataModal" class="user-modal">
      <span slot="header" class="title title-up text-primary assign-coures" style=" width: 100%">
        <span v-if="is_7days">
          {{ employeeCoursesData.first_name }} {{ employeeCoursesData.last_name }}'s Assigned Courses (Due in 7 Days)
        </span>
        <span v-else>
          {{ employeeCoursesData.first_name }} {{ employeeCoursesData.last_name }}'s Assigned Courses (Non Compliant)
        </span>

        <span style="float:right;">
          <base-button name="Assign Course Screen" type="primary" @click.prevent="
            showAssigncourse(course_employee_id, course_company_id)
            ">
            Assign course
          </base-button>
        </span>
      </span>
      <div class="col-md-12"></div>
      <form>
        <div class="user-eltable table-full-width table-style-fancy border overflow-hidden">
          <el-table
            :data="is_7days ? employeeCoursesData.courseData : employeeCoursesData.courseData.filter(course => course.employee_course_status === 0 || course.employee_course_status === 3)"
            class="assignedGrid" header-row-class-name="thead-light custom-thead-light">
            <el-table-column align="left" label="Lesson name" min-width="180px" property="" class-name="left-align">
              <template slot-scope="props">
                <span>{{ props.row.name }}</span>
              </template>
            </el-table-column>
            <el-table-column align="left" label="Lesson Status" min-width="150px" property="" class-name="center-align">
              <template slot-scope="props">
                <span v-if="props.row.employee_course_status === 1" style="color: #05bf70">Passed</span>
                <span v-if="props.row.employee_course_status === 2" style="color: #ffd600">Open</span>
                <span v-if="props.row.employee_course_status === 0" style="color: #f50636">Failed</span>
                <span v-if="props.row.employee_course_status === 3" style="color: #f50636">Expired</span>
              </template>
            </el-table-column>
            <!--employee_course_due_date-->
            <el-table-column align="left" label="Date Completed" min-width="150px" property="">
              <template slot-scope="props">
                <span v-if="props.row.employee_course_date_completed === null">Not Available</span>
                <span v-else>{{ formattedDate(props.row.employee_course_date_completed) }}</span>
              </template>
            </el-table-column>
            <el-table-column align="left" label="Date Assigned" min-width="150px" property="">
              <template slot-scope="props">
                <span>{{ formattedDate(props.row.employee_course_date_assigned) }}</span>
              </template>
            </el-table-column>
            <el-table-column align="left" label="Due Date" min-width="150px" property="">
              <template slot-scope="props">
                <span>{{ formattedDate(props.row.employee_course_due_date) }}</span>
              </template>
            </el-table-column>
            <el-table-column align="left" label="Action" min-width="150px" property="">
              <template slot-scope="props">
                <base-button class="" size="sm" style="cursor: pointer" type=""
                  @click="unAssignedCourse(props.$index, props.row)">
                  <img class="ico-del" src="/img/icons/common/delete-icon.svg" alt="" />
                  <!-- <i class="fa fa-trash"></i> -->
                </base-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="text-center my-4"></div>
        <div class="clearfix"></div>
      </form>
    </modal>
    <modal :show.sync="show2faModal">
      <h3 slot="header" class="title title-up text-primary text-center"><u>Two-Factor Authentication Required to
          Continue</u></h3>
      <form>
        <div class="row">
          <div class="col-md-12">
            <h5> This course requires a Two-Factor Authentication to verify your identity. We will send you
              a
              verification code to your registered phone number. If you do not have a number on file,
              please enter
              it below.</h5>
          </div>
          <div class="col-md-12">
            <label><b>Registered Phone Number:</b></label>
          </div>

          <div class="col-md-7">
            <base-input v-model="newphonenumber" placeholder="Phone Number" type="tel"
              @input="acceptNumber"></base-input>
          </div>
          <div v-if="changePhoneNum" class="col-md-5" style="padding: 0px !important">
            <label> (<a class="linkColor" @click.prevent="cancelPhone">Cancel</a>)</label>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <label>Select verification channel:</label>
          </div>
          <div class="col-md-3">
            <input v-model="verificationType" name="verificationtype" type="radio" value="sms" />
            Text
          </div>
          <div class="col-md-3">
            <input v-model="verificationType" name="verificationtype" type="radio" value="call" />
            Call
          </div>
          <div class="col-md-12 mt-4">
            <base-button size="sm" type="success" @click.prevent="sendVerification">Start
              Verification
            </base-button>
          </div>
        </div>
      </form>
    </modal>
    <modal :show.sync="askOtpModal">
      <h3 slot="header" class="title title-up text-primary text-center">Enter Code</h3>
      <form>
        <div class="row">
          <div class="col-md-6">
            <base-input v-model="otp" placeholder="Enter Code" type="number"></base-input>
          </div>
          <div class="col-md-6">
            <base-button size="sm" type="success" @click.prevent="verifyOtp">Verify</base-button>
          </div>
        </div>
      </form>
    </modal>
    <modal v-if="payCourseModel" :show.sync="payCourseModel">
      <h4 slot="header" class="modal-title mb-0" style="color: #444c57">Payment</h4>
      <pay-by-employee :address="this.address" :amountPayable="discountedCost" :city="this.city"
        :discount="is_payByEmployeeDiscount" :orignalAmount="orignalCost" :state="this.state" :zipcode="this.zipcode"
        type="payByEmployee" v-on:payClicked="payClicked" />
    </modal>
    <modal :show.sync="courseAssigneeModal">
      <h3 slot="header" style="color: #444c57" class="title title-up">
        Assign Course
      </h3>
      <form>
        <div class="row">
          <div class="col-md-12 text-right">
            <base-button type="primary" name="Assign Course" @click.prevent="assignCourse">
              {{ assigning ? "Processing" : "Assign Course" }}
            </base-button>
          </div>
          <div class="col-md-12 select-style">
            <base-input label="Select any Course to Assign:">
              <el-select multiple filterable v-model="assigned_course_id" class="course_dropdown" name="course">
                <el-option v-for="(course, index) in courses" name="course" :key="index" :label="course.name"
                  :value="course.id">
                </el-option>
              </el-select>
            </base-input>
          </div>
        </div>
        <div class="clearfix"></div>
      </form>
    </modal>
    <modal :show.sync="showReportModal" class="">
      <h3 slot="header" class="title title-up text-primary">
        Report an Issue or Share Feedback
      </h3>
      <small>
        <strong>
          If you’ve encountered a problem or have suggestions to improve your experience, please let us know. Your input
          helps us serve you better.
        </strong>
      </small>
      <div class="row mt-2">
        <div class="col-md-12">
          <!-- Name Input -->
          <div class="form-group">
            <label>Name</label>
            <input type="text" v-model="account.name" placeholder="Name" class="form-control" />
          </div>

          <!-- Email Input (readonly) -->
          <div class="form-group">
            <label>Email</label>
            <input type="email" v-model="account.email" placeholder="Email" class="form-control" />
          </div>

          <base-input label="Select Issue">
            <el-select class="select-primary" v-model="account.issue" placeholder="Select Issue"
              v-on:change="changePage(1)">
              <el-option class="select-primary" v-for="item in feedbackCategories" :key="item.key" :label="item.value"
                :value="item.value">
              </el-option>
            </el-select>
          </base-input>

          <div class="form-group">
            <label>Comments</label>
            <textarea v-model="account.comments" placeholder="Enter your comments here..." class="form-control"
              rows="4"></textarea>
          </div>
          <div class="text-right">
            <base-button class="greybtn" outline @click="hideModal()">
              Close
            </base-button>
            <base-button type="primary" @click="submitData()">
              Submit
            </base-button>
          </div>
        </div>
      </div>

    </modal>
    <modal :show.sync="showAgreementModal" title="User Agreement">
      <h1>{{ agreement.title }}</h1>

      <div v-html="agreement.content" class="agreement-content"></div>

      <template #footer>
        <button class="btn btn-primary" @click="acceptAgreement">
          Confirm
        </button>
      </template>
    </modal>
  </div>
</template>
<script>
import moment from "moment";
// Components
import { Dropdown, DropdownItem, DropdownMenu, Option, Select, Table, TableColumn } from "element-ui";
import clientPaginationMixin from "../Tables/PaginatedTables/clientPaginationMixin";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
import Companies from "../Super/Companies.vue";
import PofPieChart from "./PofPieChart.vue";
import CompletionsGraph from "./CompletionsGraph.vue";
import MostRecentCompletions from "./MostRecentCompletions.vue";
import PayByEmployee from "@/views/Super/PayByEmployee.vue";
import { formatDateLocal } from "@/util/dateFormatter";
import FolderProgressGraph from "@/views/Super/FolderProgressGraph.vue";

import { brandContext } from "@/brand/brandContext";


// Vue.component('apexchart', VueApexCharts)
function randomScalingFactor() {
  return Math.round(Math.random() * 100);
}

export default {
  mixins: [clientPaginationMixin],
  components: {
    Companies,
    PayByEmployee,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    PofPieChart,
    CompletionsGraph,
    MostRecentCompletions,
    FolderProgressGraph,
  },
  data() {
    return {
      showReportModal: false,
      showAgreementModal: false,
      agreement: {},
      feedbackCategories: [
        { key: 'general_feedback', value: 'General Feedback' },
        { key: 'logging_in', value: 'Logging In' },
        { key: 'course_taking', value: 'Course Taking' },
        { key: 'course_assigning', value: 'Course Assigning' },
        { key: 'user_creation_updating', value: 'User Creation/Updating' },
        { key: 'location_creation_updating', value: 'Location Creation/Updating' },
        { key: 'platform_not_working', value: 'Platform Not Working' },
        { key: 'other', value: 'Other' }
      ],
      account: {
        name: localStorage.getItem("hot-user-full-name") || "",
        email: localStorage.getItem("hot-email") || "",
        issue: "",
        comments: '',
      },
      assigned_course_id: "",
      total_cer: 0,
      usrname: "",
      progressButtonContent: false,
      baseUrl: this.$baseUrl,
      show2faModal: false,
      is_authenticated: 0,
      phonenumber: "",
      newphonenumber: "",
      verificationType: "sms",
      changePhoneNum: false,
      askOtpModal: false,
      otp: "",
      employee_data: [],
      is_7days: false,
      employeeDataModal: false,
      courses: [],
      projects: [],
      tableData: [],
      tbl_data: [],
      selectedRows: [],
      locations: [],
      items: [],
      status: [
        {
          label: "Active",
          value: "Active",
        },
        {
          label: "Inactive",
          value: "Inactive",
        },
        {
          label: "Show All",
          value: "",
        },
      ],
      month_count: [],
      report_type: "",
      hot_user: "",
      hot_token: "",
      editor: "",
      active_non_complaint: "",
      active_companies: "",
      active_employees: "",
      active_courses: "",
      active_location: "1",
      employeeEmailData: {
        first_name: "",
        last_name: "",
        location: "",
        id: "",
      },
      byMonth: [],
      compliance: "",
      employeeCoursesData: {
        first_name: "",
        last_name: "",
        location: "",
        courseData: [],
      },
      course_employee_id: "",
      user_id: "",
      passed: "",
      opened: "",
      failed: "",
      expired: "",
      is_payByEmployeeOn: 0,
      payCourseModel: false,
      is_payByEmployeeDiscount: "0",
      discountedCost: 0,
      orignalCost: 0,
      address: "",
      city: "",
      state: "",
      zipcode: "",
      canViewCompany: true,
      canViewUser: true,
      canViewCourse: true,
      folderProgress: "",
      adminCompanyId: '',
      companyAdminlocations: [],
      currentPage: 1,
      perPage: 10,
      totalPages: 0,
      currentPageTwo: 1,
      perPageTwo: 5,
      totalPagesTwo: 0,
      courseAssigneeModal: false,
      assigning: false,
      freeTrail: false,
      nonCompliancePagination: {
        current_page: 1,
        per_page: 10,
        total: 0,
        last_page: 1,
      },
      coursesDuePagination: {
        current_page: 1,
        per_page: 5,
        total: 0,
        last_page: 1,
      },
    };
  },
  async mounted() {
    this.account.email = localStorage.getItem("hot-email") || "";
    if (localStorage.getItem("hot-sidebar") === "admin") {
      this.usrname = localStorage.getItem("hot-user-full-name");
    } else if (localStorage.getItem("hot-user") === "employee") {
      this.usrname = localStorage.getItem("hot-user-name");

    } else if (localStorage.getItem("hot-user") === "super-admin") {
      this.usrname = "Admin";

    } else if (localStorage.getItem("hot-user") === "manager") {
      this.usrname = localStorage.getItem("hot-user-name");
    }
    if (localStorage.getItem("hot-user") !== "super-admin") {
      await this.checkAgreement();
    }
  },
  computed: {
    brand() {
      return brandContext.state;
    },
    isSafeDig() {
      return process.env.VUE_APP_COMPANY_NAME_FRONTEND === 'safedig';
    },
    dashboardWelcomeTagline() {
      if (localStorage.getItem("hot-user") === "super-admin" && this.isSafeDig) {
        return 'Welcome to the Safe Dig Admin Dashboard';
      }
      if (
        this.isSafeDig &&
        localStorage.getItem("hot-user") === "company-admin"
      ) {
        return "Dig Into Team Performance";
      }
      return this.isSafeDig
        ? "Let's Dig Into Safety"
        : 'Welcome To Your HOT Dashboard';
    },
    overviewActiveCompaniesIcon() {
      return this.isSafeDig
        ? require('@/assets/safe-dig/svg-icons/active-companies.svg')
        : '/img/svg-icons/active-companies.svg';
    },
    overviewActiveUserIcon() {
      return this.isSafeDig
        ? require('@/assets/safe-dig/svg-icons/active-user.svg')
        : '/img/svg-icons/dash-active-user.svg';
    },
    overviewActiveCoursesIcon() {
      return this.isSafeDig
        ? require('@/assets/safe-dig/svg-icons/active-courses.svg')
        : '/img/svg-icons/dash-courses.svg';
    },
    overviewDashUserIcon() {
      return this.isSafeDig
        ? require('@/assets/safe-dig/svg-icons/dash-user.svg')
        : 'img/svg-icons/dash-user.svg';
    },
    overviewDashLocationIcon() {
      return this.isSafeDig
        ? require('@/assets/safe-dig/svg-icons/dash-location.svg')
        : 'img/svg-icons/dash-location.svg';
    },
    overviewDashCoursesIcon() {
      return this.isSafeDig
        ? require('@/assets/safe-dig/svg-icons/active-courses.svg')
        : 'img/svg-icons/dash-courses.svg';
    },
    overviewDashCertificateIcon() {
      return this.isSafeDig
        ? require('@/assets/safe-dig/svg-icons/dash-certificate.svg')
        : 'img/svg-icons/dash-certificate.svg';
    },
    emptySlotIcon() {
      return this.isSafeDig
        ? require('@/assets/safe-dig/svg-icons/safedig_empty_slot.svg')
        : 'img/theme/empty_slot.png';
    },
    playIcon() {
      return this.isSafeDig
        ? require('@/assets/safe-dig/svg-icons/play_btn.svg')
        : '/play_btn.svg';
    },
    courseStatusIcons() {
      if (this.isSafeDig) {
        return {
          open: require('@/assets/safe-dig/svg-icons/opened_courses.svg'),
          passed: require('@/assets/safe-dig/svg-icons/passesd_courses.svg'),
          failed: require('@/assets/safe-dig/svg-icons/failed_courses.svg'),
          expired: require('@/assets/safe-dig/svg-icons/expired_courses.svg')
        };
      }
      return {
        open: 'img/svg-icons/opened_courses.svg',
        passed: 'img/svg-icons/passesd_courses.svg',
        failed: 'img/svg-icons/failed_courses.svg',
        expired: 'img/svg-icons/expired_courses.svg'
      };
    },
    // paginatedData() {
    //   const start = (this.currentPage - 1) * this.perPage;
    //   const end = start + this.perPage;
    //   return this.tableData.slice(start, end);
    // },
    // paginatedDataTwo() {
    //   const start = (this.currentPageTwo - 1) * this.perPageTwo;
    //   const end = start + this.perPageTwo;
    //   return this.tbl_data.slice(start, end);
    // },
    getNonCompliancePageNumbers() {
      const current = this.nonCompliancePagination.current_page
      const last = this.nonCompliancePagination.last_page
      const pages = []

      const start = Math.max(1, current - 2)
      const end = Math.min(last, current + 2)

      for (let i = start; i <= end; i++) {
        pages.push(i)
      }

      return pages;
    }
    ,

    getCoursesDuePageNumbers() {
      const current = this.coursesDuePagination.current_page
      const last = this.coursesDuePagination.last_page
      const pages = []

      const start = Math.max(1, current - 2)
      const end = Math.min(last, current + 2)

      for (let i = start; i <= end; i++) {
        pages.push(i)
      }

      return pages;
    }

  },
  created: function () {
    this.account.email = localStorage.getItem("hot-email") || "";

    if (localStorage.getItem("hot-token")) {
      this.hot_user = localStorage.getItem("hot-user");
      this.hot_token = localStorage.getItem("hot-token");
    }
    if (localStorage.getItem("hot-user") === "employee") {
      this.editor = "employee";
    } else if (localStorage.getItem("hot-user") === "super-admin") {
      this.editor = "super-admin";
    } else if (localStorage.getItem("hot-user") === "sub-admin") {
      this.editor = "sub-admin";
      this.getRightsDetails();
    } else if (localStorage.getItem("hot-user") === "company-admin") {
      this.editor = "company";
    } else if (localStorage.getItem("hot-sidebar") === "manager") {
      this.editor = "manager";
    }
    if (this.editor === "super-admin" || this.editor === "sub-admin") {
      this.$http.get("company/admin_stats").then((resp) => {
        this.active_courses = resp.data.courses.toString();
        this.active_companies = resp.data.companies.toString();
        this.active_employees = resp.data.employees.toString();
      });
    }
    if (this.editor === "company" || this.editor === "manager") {
      this.company_id = localStorage.getItem("hot-user-id");
      // this.manager_id=localStorage.getItem("hot-admin-id");
      // this.adminCompanyId = this.company_id;
      this.$http.post("location/all", {
        company_id: this.company_id
      }).then(resp => {
        let parentCompanyId = resp.data[0].parent_id;
        let isParentCompanyAvailable = false;
        this.companyAdminlocations = [];
        if (this.editor === "company") {
          this.companyAdminlocations.push({
            label: 'All',
            value: 'all'
          });
        }
        // this.companyAdminlocations.push({
        //   label: 'All',
        //   value: 'all'
        // });
        if (resp.data) {
          for (let loc of resp.data) {
            let obj = {
              label: loc.name,
              value: loc.id
            };
            if (loc.id == parentCompanyId) {
              isParentCompanyAvailable = true;
            }
            this.companyAdminlocations.push(obj);
          }


        }
        if (isParentCompanyAvailable == false) {
          this.adminCompanyId = parseInt(resp.data[0].id);
        } else {
          this.adminCompanyId = parseInt(parentCompanyId);
        }
      }).finally(() => {
        this.loading = false;
      });

      this.getCompanyStats();
      this.certificateCountCheck();
      this.refreshNon();
      this.refreshDue();
      // this.getCompanyCourses();
      // this.getComplianceCount();
      this.checkFreeTrail();
    }
    if (this.editor === "employee") {
      this.user_id = localStorage.getItem("hot-user-id");
      this.$http.get("employees/stats/" + this.user_id).then((resp) => {
        this.passed = resp.data.pass.toString();
        this.opened = resp.data.open.toString();
        this.failed = resp.data.fail.toString();
        this.expired = resp.data.expired.toString();
      });
      this.employeeCourses();

      this.folderProgressData();
    }


  },
  updated: function () {
    window.dispatchEvent(new Event('resize'));
  },
  methods: {
    submitData() {
      this.$http
        .post("support", {
          name: this.account.name,
          email: this.account.email,
          issue: this.account.issue,
          comments: this.account.comments,
        })
        .then((resp) => {
          Swal.fire({
            icon: 'success',
            title: 'Message Sent',
            text: resp.data.message || 'Your support request was sent successfully!',
          });
          this.account = {
            name: "",
            email: "",
            issue: "",
            comments: ''
          };
          this.hideModal();
        })
        .catch((error) => {
          let errorText = "Something went wrong. Please try again.";

          // Laravel validation error (422)
          if (error.response && error.response.status === 422) {
            if (typeof error.response.data.errors === 'object') {
              const messages = Object.values(error.response.data.errors)
                .flat()
                .join('\n');
              errorText = messages;
            } else if (error.response.data.message) {
              errorText = error.response.data.message;
            }
          }

          // Laravel general error
          else if (error.response && error.response.data && error.response.data.message) {
            errorText = error.response.data.message;
          }

          Swal.fire({
            icon: 'error',
            title: 'Submission Failed',
            text: errorText,
          });
        });
    },

    showModal() {
      this.showReportModal = true;
    },
    hideModal() {
      this.showReportModal = false;
    },
    cancelTrail() {
      Swal.fire({
        title: "Are you sure?",
        text: "Do you really want to cancel the Free Trial?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-danger",
        cancelButtonClass: "btn btn-secondary",
        confirmButtonText: "Yes, cancel it!",
        cancelButtonText: "No, keep it",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$http
            .post("cancel-trail")
            .then(resp => {
              Swal.fire({
                title: "Success!",
                text: resp.data.message || "Your Free Trial has been cancelled",
                icon: "success",
                confirmButtonClass: "btn btn-success",
              });
              window.location.reload();
            })
            .catch(error => {
              Swal.fire({
                title: "Error!",
                text: error.response?.data?.message || "Something went wrong while cancelling the Free Trial.",
                icon: "error",
                confirmButtonClass: "btn btn-danger",
              });
            })
            .finally(() => (this.loading = false));
        }
      });
    },
    activeTrail() {
      this.$http
        .post("payment-trail")
        .then(resp => {
          Swal.fire({
            title: "Success!",
            text: resp.data.message || "Your Free Trial has been activated",
            icon: "success",
            confirmButtonClass: "btn btn-success",
          });
          window.location.reload();
        })
        .catch(error => {
          Swal.fire({
            title: "Error!",
            text: error.response?.data?.message || "Something went wrong while activating the Free Trial.",
            icon: "error",
            confirmButtonClass: "btn btn-danger",
          });
        })
        .finally(() => (this.loading = false));
    },
    checkFreeTrail() {
      this.$http
        .post("check-freetrail",).then(resp => {
          if (resp.data.free_trail == true) {
            this.freeTrail = true;
          } else {
            this.freeTrail = false;
          }
        })
        .finally(() => (this.loading = false));
    },
    assignCourse() {
      this.assigning = true;
      if (this.assigned_course_id !== "") {
        let data = {
          course_id: this.assigned_course_id,
          company_id: this.course_company_id,
          assign_to: [
            {
              employee_ids: [],
              assign_to: "employee"
            }
          ]
        };

        if (this.selectedRows.length > 0) {
          for (let id of this.selectedRows) {
            let obj = {
              id: id
            };
            data.assign_to[0].employee_ids.push(obj);
          }
        } else {
          let obj = {
            id: this.course_employee_id
          };
          data.assign_to[0].employee_ids.push(obj);
        }

        this.$http
          .post("course/assign", data, this.config)
          .then(resp => {
            this.assigning = false;
            this.courseAssigneeModal = false;
            this.bulkValue = "";
            this.assigned_course_id = "";
            this.selectedRows = [];

            this.employeeDataModal = false;


            if (resp.data.alreadyPassed == 0 && resp.data.alreadyInProgress == 0) {
              Swal.fire({
                title: "Success!",
                text: "Course(s) has been Assigned to Employee(s)",
                icon: "success",
                confirmButtonClass: "btn btn-success",
              });
            } else {
              Swal.fire({
                title: "Success!",
                html: '<ul style="text-align: left;"><li>Course(s) Assigned: ' + resp.data.assigned + '</li><li>Course(s) In Progress: ' + resp.data.alreadyInProgress + '</li><li>Course(s) Already Passed: ' + resp.data.alreadyPassed + '</li></ul>',
                icon: "success",
                confirmButtonClass: "btn btn-success",

              });
            }
            this.refreshDue();
            this.refreshNon();

          })
          .catch(function (error) {
            Swal.fire({
              title: "Error!",
              html: error.response.data.message,
              icon: "error",
              confirmButtonClass: "btn btn-success",

            });
          });
      } else {
        this.assigning = false;
        Swal.fire({
          title: "Error!",
          text: "All fields are required!",
          icon: "error",
          confirmButtonClass: "btn btn-success",


        });
      }
    },
    showAssigncourse(row, course_company_id) {
      this.course_employee_id = row;
      this.course_company_id = course_company_id;
      this.courseAssigneeModal = true;
      this.getCompanyCourses();
    },
    // totalPages() {
    //   return Math.ceil(this.tableData.length / this.perPage);
    // },
    goToPage(page) {
      this.currentPage = page;
    },
    previousPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    goToPageTwo(page) {
      this.currentPageTwo = page;
    },
    previousPageTwo() {
      if (this.currentPageTwo > 1) {
        this.currentPageTwo--;
      }
    },
    nextPageTwo() {
      if (this.currentPageTwo < this.totalPagesTwo) {
        this.currentPageTwo++;
      }
    },
    certificateCountCheck() {
      this.$http
        .post("course/certificatesList",).then(resp => {
          this.total_cer = resp.data.total_active_certificates;
        })
        .finally(() => (this.loading = false));
    },

    getRightsDetails() {
      let type = "All";
      this.$http.get("subadmin/subadmin_rights/" + type).then((resp) => {
        this.canViewCompany = resp.data[0].permissions.indexOf("v") !== -1 ? true : false;
        this.canViewUser = resp.data[1].permissions.indexOf("v") !== -1 ? true : false;
        this.canViewCourse = resp.data[2].permissions.indexOf("v") !== -1 ? true : false;
      });
    },
    changePhone() {
      this.changePhoneNum = true;
    },
    cancelPhone() {
      this.newphonenumber = "";
      this.changePhoneNum = false;
    },
    //employee
    folderProgressData() {
      this.$http.get("employees/employeeCourseFolderProgress").then((response) => {
        this.folderProgress = response.data;
      }).catch((error) => {
        console.log("API failed for loading progress data");
      });
    },
    employeeCourses() {
      this.$http
        .post("employees/courses", {
          search: this.searchQuery,
          employee_id: this.user_id,
          section: "dashboard",
        })
        .then((resp) => {
          this.tableData = [];
          let course_data = resp.data.courses;
          let employee_data = resp.data.employee;
          this.address = employee_data.address;
          this.state = employee_data.state;
          this.city = employee_data.city;
          this.zipcode = employee_data.zipcode;
          this.is_authenticated = employee_data.is_2f_authenticated;
          this.phonenumber = employee_data.phone_num;
          let payby_employee = resp.data.company_pay_by_employee;
          if (payby_employee != null) {
            this.company_id = payby_employee.company_id;
            this.is_payByEmployeeOn = payby_employee.pay_employee_status;
            this.is_payByEmployeeDiscount = payby_employee.pay_employee_discount;
          }
          for (let data of course_data) {
            let obj = {
              id: data.course_id,
              course_name: data.name,
              course_length: data.length,
              course_cost: data.cost,
              discountedCost: "",
              due_date: data.employee_course_due_date,
              course_status: data.employee_course_status,
              is_2fa_required: "",
              video: data.video,
              img: data.image_url
            };
            if (data.course_paid_status === 0) {
              obj.discountedCost = obj.course_cost - obj.course_cost * (this.is_payByEmployeeDiscount / 100);
              obj.is_employee_paid = false;
            } else {
              obj.is_employee_paid = true;
            }
            if (data.is_2fa_required === 1) {
              obj.is_2fa_required = true;
            } else {
              obj.is_2fa_required = false;
            }
            this.tableData.push(obj);
          }
        });
    },

    takingCourse(course_id, due_date, is_2fa_required) {
      if (is_2fa_required && this.is_authenticated == 0) {
        this.show2faModal = true;
      } else {
        this.$router.push("/course_instructions?id=" + course_id + "&due_date=" + due_date);
      }
    },
    sendVerification() {
      let data = {
        phone_no: "",
        chanel_type: this.verificationType,
      };
      if (this.newphonenumber) {
        data.phone_no = this.newphonenumber;
      } else {
        data.phone_no = this.phonenumber;
      }
      this.$http
        .post("twilio/sendOTP", data)
        .then((resp) => {
          this.askOtpModal = true;
          Swal.fire({
            title: "Success!",
            text: "Otp sent to your phone number.",
            icon: "success",
            icon: "success",
            confirmButtonClass: "btn btn-success",
          });
        })
        .catch(function (error) {
          Swal.fire({
            title: "Error!",
            text: "Something went wrong!",
            icon: "error",
            icon: "success",
            confirmButtonClass: "btn btn-success",
          });
        });
    },
    verifyOtp() {
      let data = {
        phone_no: "",
        otp: this.otp,
      };
      if (this.newphonenumber) {
        data.phone_no = this.newphonenumber;
      } else {
        data.phone_no = this.phonenumber;
      }
      this.$http
        .post("twilio/VerifysendOTP", data)
        .then((resp) => {
          this.show2faModal = false;
          this.askOtpModal = false;
          Swal.fire({
            title: "Success!",
            text: "Verified successfully.",
            icon: "success",
            icon: "success",
            confirmButtonClass: "btn btn-success",
          });
          this.employeeCourses();
        })
        .catch(function (error) {
          if (error.response.status === 422) {
            Swal.fire({
              title: "Error!",
              text: error.response.data.message,
              icon: "error",
              icon: "success",
              confirmButtonClass: "btn btn-success",
            });
          } else {
            Swal.fire({
              title: "Error!",
              text: "Something went wrong.",
              icon: "error",
              icon: "success",
              confirmButtonClass: "btn btn-success",
            });
          }
        });
    },
    payClicked(cardData, addressData) {
      let payment = {
        payment_type: "payByEmployee",
        cardholder_street_address: "",
        cardholder_zip: "",
        cardholder_city: "",
        cardholder_state: "",
        transaction_amount: "",
        token: cardData.token
      };
      if (addressData.address != "") {
        payment.cardholder_street_address = addressData.address;
        payment.cardholder_zip = addressData.zipcode;
        payment.cardholder_city = addressData.city;
        payment.cardholder_state = addressData.state;
      } else {
        payment.cardholder_street_address = this.address;
        payment.cardholder_zip = this.zipcode;
      }
      payment.transaction_amount = this.discountedCost.toFixed(2);

      this.formData.payment = payment;
      this.$http
        .post("course/pay_by_employee_submission", this.formData)
        .then((resp) => {
          Swal.fire({
            title: "Success!",
            html: `Amount Paid Sucessfully.`,
            icon: "success",
            confirmButton: "btn btn-success",
            confirmButtonText: "Ok",
          }).then((result) => {
            this.employeeCourses();
          });
        })
        .catch(function (error) {
          if (error.response.status === 422) {
            return Swal.fire({
              title: "Error!",
              text: error.response.data.message,
              icon: "error",
              icon: "success",
              confirmButtonClass: "btn btn-success",
            });
          }
        })
        .finally(() => (
          this.payCourseModel = false
        ));
    },
    PayCourse(row) {
      this.discountedCost = row.discountedCost;
      this.orignalCost = row.course_cost;
      this.formData = {
        employee_id: this.user_id,
        company_id: this.company_id,
        course_id: row.id,
        orignal_amount: row.course_cost,
        pay_by_employee_dicount: this.is_payByEmployeeDiscount,
        actual_amount: this.discountedCost,
      };
      this.payCourseModel = true;
    },
    selectionChange(selectedRows) {
      this.selectedRows = selectedRows;
    },
    currentDate(duedate) {
      var currentDateWithFormat = new Date().toJSON().slice(0, 10).replace(/-/g, "-");
      if (currentDateWithFormat > duedate) {
        return true;
      } else {
        return false;
      }
    },
    formattedDate(data) {
      return formatDateLocal(data);
    },
    sendReminderAllEmployees(val) {
      Swal.fire({
        title: "Are you sure?",
        text: "You want to send a reminder email to the entire list?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn",
        cancelButtonClass: "btn greybtn",
        confirmButtonColor: "#E0E0E0",
        cancelButtonColor: "",
        confirmButtonText: "Yes!",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.value) {
          if (val === "non_compliant") {
            this.$http
              .post("employees/non_compliant_reminder_email_list", {
                type: "non_compliant",
                company_id: this.company_id,
              })
              .then((resp) => {
                Swal.fire({
                  title: "Success!",
                  text: "Email has been sent to the entire list!",
                  icon: "success",
                  confirmButtonClass: "btn btn-success",
                });
              });
          } else {
            this.$http
              .post("employees/non_compliant_reminder_email_list", {
                type: "due",
                company_id: this.company_id,
              })
              .then((resp) => {
                Swal.fire({
                  title: "Success!",
                  text: "Email has been sent to the entire list!",
                  icon: "success",
                  confirmButtonClass: "btn btn-success",
                });
              });
          }
        }
      });
    },
    unAssignedCourse(index, row) {
      let self = this;
      Swal.fire({
        title: "Are you sure?",
        text: "You want to delete this course",
        icon: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn",
        cancelButtonClass: "btn greybtn",
        confirmButtonColor: "#E0E0E0",
        cancelButtonColor: "",
        confirmButtonText: "Yes!",
        cancelButtonText: "No",
        // buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          self.$http
            .post("employees/unassign_course", {
              course_id: row.id,
              employee_id: self.course_employee_id,
            })
            .then((resp) => {
              self.employeeDataModal = false;
              //  self.refreshDue();
              Swal.fire({
                title: "Success!",
                text: "Course has been Unassigned to this Employee!",
                icon: "success",
                confirmButtonClass: "btn btn-success",
                // buttonsStyling: true,
              }).then((result) => {
                if (result.value) {
                  self.refreshDue();
                  self.refreshNon();
                }
              });
            });
        }
      });
    },
    sendReminder(index, row) {
      let self = this;
      this.employeeEmailData.first_name = row.first_name;
      this.employeeEmailData.last_name = row.last_name;
      this.employeeEmailData.location = row.location;
      this.employeeEmailData.id = row.id;
      // let done = false;
      Swal.fire({
        title: "Are you sure?",
        icon: "warning",
        text: "You want to send Reminder Email to " + self.employeeEmailData.first_name + " " + self.employeeEmailData.last_name + "?",
        showCancelButton: true,
        confirmButtonClass: "btn",
        cancelButtonClass: "btn greybtn",
        confirmButtonColor: "#E0E0E0",
        cancelButtonColor: "",
        confirmButtonText: "Yes!",
        cancelButtonText: "No",
        // buttonsStyling: false,
      })
        .then((result) => {
          if (result.value) {
            let ids = [];
            let obj = {
              id: self.employeeEmailData.id,
            };
            ids.push(obj);
            self.$http
              .post("employees/course_expire_reminder_email", {
                company_id: self.company_id,
                ids: ids,
              })
              .then((resp) => {
                Swal.fire({
                  title: "Success!",
                  text: "Email has been sent!",
                  icon: "success",
                  confirmButtonClass: "btn btn-success",
                  // buttonsStyling: false,
                });
              });
          }
        })
        .catch(function () {
        });
    },
    sendExpiringReminder(index, row) {
      let self = this;
      this.employeeEmailData.first_name = row.first_name;
      this.employeeEmailData.last_name = row.last_name;
      this.employeeEmailData.location = row.location;
      this.employeeEmailData.id = row.id;
      // let done = false;
      Swal.fire({
        title: "Are you sure?",
        icon: "warning",
        text: "You want to send Reminder Email to " + self.employeeEmailData.first_name + " " + self.employeeEmailData.last_name + "?",
        showCancelButton: true,
        confirmButtonClass: "btn",
        cancelButtonClass: "btn greybtn",
        confirmButtonColor: "#E0E0E0",
        cancelButtonColor: "",
        confirmButtonText: "Yes!",
        cancelButtonText: "No",
        // buttonsStyling: false,
      })
        .then((result) => {
          if (result.value) {
            let ids = [];
            let obj = {
              id: self.employeeEmailData.id,
            };
            ids.push(obj);
            self.$http.post("employees/course_expiring_reminder_email", {
              company_id: self.company_id,
              ids: ids,
            }).then((resp) => {
              Swal.fire({
                title: "Success!",
                text: "Email has been sent!",
                icon: "success",
                confirmButtonClass: "btn btn-success",
                // buttonsStyling: false,
              });
            }).catch((error) => {
              Swal.fire({
                title: "Error!",
                text: error.response.data.Email,
                icon: "error",
                confirmButtonClass: "btn btn-success",
                // buttonsStyling: false,
              });
            });
          }
        })
    },
    handleEdit(index, row) {
      this.$router.push("/add_location?id=" + row.id);
    },
    handleDelete(index, row) {
      let indexToDelete = this.tableData.findIndex((tableRow) => tableRow.id === row.id);
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    },
    openCourseDetailsDue(row, val = false) {
      if (val) {
        this.is_7days = true;
      } else {
        this.is_7days = false;
      }
      this.course_employee_id = row.id;
      this.employeeCoursesData.first_name = row.first_name;
      this.employeeCoursesData.last_name = row.last_name;
      this.employeeCoursesData.location = row.location;
      this.employeeCoursesData.courseData = row.courses;
      this.course_company_id = row.company_id;
      this.employeeDataModal = true;
    },
    // refreshNon() {
    //   this.$http
    //   .post("employees/non_compliance", {
    //     search: this.searchQuery,
    //     company_id: this.adminCompanyId,
    //   })
    //   .then((resp) => {
    //     this.tableData = [];
    //     let employee_data = resp.data.employee;
    //     console.log(employee_data, "data showing on page")

    //     for (let data of employee_data) {
    //     let obj = {
    //       id: data.id,
    //       first_name: data.first_name,
    //       last_name: data.last_name,
    //       company: data.company_name,
    //       pof: data.course_pass_count + " | " + data.course_open_count + " | " + (data.course_fail_count + data.course_expired_count),
    //       pass: data.course_pass_count,
    //       fail: data.course_fail_count + data.course_expired_count,
    //       open: data.course_open_count,
    //       assigned_lessons: parseInt(data.course_pass_count) + parseInt(data.course_open_count) + parseInt(data.course_fail_count + data.course_expired_count),
    //       lesson_passed: data.course_pass_count,
    //       lesson_outstanding: data.course_fail_count + data.course_expired_count,
    //       courses: data.courses,
    //     };
    //     this.tableData.push(obj);
    //     }
    //     this.tableData.sort((a, b) => a.first_name.localeCompare(b.first_name));
    //     this.totalPages = Math.ceil(this.tableData.length / this.perPage);
    //     this.currentPage = 1; // Reset to first page when data changes
    //   });
    // },
    // refreshDue() {
    //   this.$http
    //   .post("employees/course_due", {
    //     search: this.searchQuery,
    //     company_id: this.adminCompanyId,
    //   })
    //   .then((resp) => {
    //     let employee_data = resp.data.employee;
    //     this.tbl_data = [];
    //     for (let data of employee_data) {
    //     let obj = {
    //       id: data.id,
    //       first_name: data.first_name,
    //       last_name: data.last_name,
    //       company: data.company_name,
    //       pof: data.course_pass_count + " | " + data.course_open_count + " | " + (data.course_fail_count + data.course_expired_count),
    //       pass: data.course_pass_count,
    //       fail: data.course_fail_count + data.course_expired_count,
    //       open: data.course_open_count,
    //       assigned_lessons: parseInt(data.course_pass_count) + parseInt(data.course_open_count) + parseInt(data.course_fail_count + data.course_expired_count),
    //       lesson_passed: data.course_pass_count,
    //       lesson_outstanding: data.course_fail_count,
    //       courses: data.courses_due,
    //     };
    //     this.tbl_data.push(obj);
    //     }
    //     this.tbl_data.sort((a, b) => a.first_name.localeCompare(b.first_name));
    //     this.totalPagesTwo = Math.ceil(this.tbl_data.length / this.perPageTwo);
    //     this.currentPageTwo = 1; // Reset to first page when data changes
    //   });
    // },
    refreshNon() {
      this.loadNonComplianceData(1) // Start from page 1\
    },
    // ADD this new method:
    loadNonComplianceData(page = 1) {
      this.$http
        .post("employees/non_compliance", {
          search: this.searchQuery,
          company_id: this.adminCompanyId,
          page: page,
          per_page: this.nonCompliancePagination.per_page,
        })
        .then((resp) => {
          this.tableData = []
          const employee_data = resp.data.employee

          // Process employee data (same logic as before)
          for (const data of employee_data) {
            const obj = {
              id: data.id,
              first_name: data.first_name,
              last_name: data.last_name,
              company: data.company_name,
              pof:
                data.course_pass_count +
                " | " +
                data.course_open_count +
                " | " +
                (data.course_fail_count + data.course_expired_count),
              pass: data.course_pass_count,
              fail: data.course_fail_count + data.course_expired_count,
              open: data.course_open_count,
              assigned_lessons:
                Number.parseInt(data.course_pass_count) +
                Number.parseInt(data.course_open_count) +
                Number.parseInt(data.course_fail_count + data.course_expired_count),
              lesson_passed: data.course_pass_count,
              lesson_outstanding: data.course_fail_count + data.course_expired_count,
              courses: data.courses,
            }
            this.tableData.push(obj)
          }

          this.tableData.sort((a, b) => a.first_name.localeCompare(b.first_name))

          // UPDATE pagination info
          if (resp.data.pagination) {
            this.nonCompliancePagination = resp.data.pagination
          }
        })
    },

    // REPLACE your existing refreshDue() method with this:
    refreshDue() {
      this.loadCoursesDueData(1) // Start from page 1\
    },

    // ADD this new method:
    loadCoursesDueData(page = 1) {
      this.$http
        .post("employees/course_due", {
          search: this.searchQuery,
          company_id: this.adminCompanyId,
          page: page,
          per_page: this.coursesDuePagination.per_page,
        })
        .then((resp) => {
          const employee_data = resp.data.employee
          this.tbl_data = []

          // Process employee data (same logic as before)
          for (const data of employee_data) {
            const obj = {
              id: data.id,
              first_name: data.first_name,
              last_name: data.last_name,
              company: data.company_name,
              pof:
                data.course_pass_count +
                " | " +
                data.course_open_count +
                " | " +
                (data.course_fail_count + data.course_expired_count),
              pass: data.course_pass_count,
              fail: data.course_fail_count + data.course_expired_count,
              open: data.course_open_count,
              assigned_lessons:
                Number.parseInt(data.course_pass_count) +
                Number.parseInt(data.course_open_count) +
                Number.parseInt(data.course_fail_count + data.course_expired_count),
              lesson_passed: data.course_pass_count,
              lesson_outstanding: data.course_fail_count,
              courses: data.courses_due,
            }
            this.tbl_data.push(obj)
          }

          this.tbl_data.sort((a, b) => a.first_name.localeCompare(b.first_name))

          // UPDATE pagination info
          if (resp.data.pagination) {
            this.coursesDuePagination = resp.data.pagination
          }
        })
    },
    // ADD these new pagination methods:
    changeNonCompliancePage(page) {
      if (page >= 1 && page <= this.nonCompliancePagination.last_page) {
        this.loadNonComplianceData(page)
      }
    },
    changeCoursesDuePage(page) {
      if (page >= 1 && page <= this.coursesDuePagination.last_page) {
        this.loadCoursesDueData(page)
      }
    },
    getCompanyStats: function () {
      this.$http.get("company/stats/" + this.adminCompanyId).then((resp) => {
        this.active_courses = resp.data.courses.toString();
        if (resp.data.location != "0") {
          this.active_location = resp.data.location.toString();
        }
        this.active_employees = resp.data.employee.toString();
      });
    },
    getCompanyCourses: function () {
      this.$http.get("company/courses/" + this.adminCompanyId).then((resp) => {
        this.courses = resp.data[0].courses;

      });
    },
    getComplianceCount: function () {
      this.$http.get("analytics/compliance_count").then((response) => {

        this.compliance = response.data.length;
      }).catch((error) => {
        console.log("API failed for loading Compliance data");
      });
    },
    acceptNumber() {
      var x = this.newphonenumber.replace(/\D/g, "").match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
      this.newphonenumber = !x[2] ? x[1] : "(" + x[1] + ") " + x[2] + (x[3] ? "-" + x[3] : "");
    },
    handleSizeChange(size) {
      this.pagination.perPage = size;
    },
    handleCurrentChange(page) {
      this.pagination.currentPage = page;
    },
    async checkAgreement() {
      try {
        const { data } = await this.$http.get('agreement/check');
        if (data.data.show_agreement) {
          this.agreement = data.data.agreement;
          this.showAgreementModal = true;
        }
      } catch (err) {
        console.error('Agreement check failed', err);
      }
    },
    async acceptAgreement() {
      try {
        await this.$http.get('agreement/accept');
        this.showAgreementModal = false;
        this.$toast.success('Agreement accepted', {
          timeout: 5000,
        });
      } catch (err) {
        this.$toast.error('Failed to accept agreement', {
          timeout: 5000,
        });
      }
    },
  },
  watch: {
    adminCompanyId: function () {
      this.refreshDue();
      this.refreshNon();
      this.getCompanyStats();
      // this.getCompanyCourses();
    }
  }
};
</script>
<style>
.company-location-dropdown .el-select .el-input .el-input__inner {
  height: 30px !important;
}

.company-location-dropdown .el-select .el-input span {
  display: flex;
  align-items: center;
}

.company-location-dropdown .el-select .el-input span:hover {
  text-decoration: none;
}

.customInput_box .el-input.el-input--suffix input.el-input__inner {
  height: 30px;
}
</style>
<style scoped>
@media only screen and (max-width: 1024px),
(min-device-width: 768px) and (max-device-width: 1024px) {
  .nonGrid>>>table.el-table__body td:nth-of-type(1):before {
    content: "Full Name";
  }

  /* .nonGrid>>>table.el-table__body td:nth-of-type(2):before {
    content: "Last Name";
  } */
  .nonGrid>>>table.el-table__body td:nth-of-type(2):before {
    content: "Location";
  }

  .nonGrid>>>table.el-table__body td:nth-of-type(3):before {
    content: "P/O/F";
  }

  .nonGrid>>>table.el-table__body td:nth-of-type(4):before {
    content: "Action";
  }

  .dueGrid>>>table.el-table__body td:nth-of-type(1):before {
    content: "Full Name";
  }

  /* .dueGrid>>>table.el-table__body td:nth-of-type(2):before {
    content: "Last Name";
  } */
  .dueGrid>>>table.el-table__body td:nth-of-type(2):before {
    content: "Location";
  }

  .dueGrid>>>table.el-table__body td:nth-of-type(3):before {
    content: "P/O/F";
  }

  .dueGrid>>>table.el-table__body td:nth-of-type(4):before {
    content: "Action";
  }

  .courseGrid>>>table.el-table__body td:nth-of-type(1):before {
    content: "Course Name" !important;
  }

  .courseGrid>>>table.el-table__body td:nth-of-type(2):before {
    content: "Due Date";
  }

  .courseGrid>>>table.el-table__body td:nth-of-type(3):before {
    content: "Lesson status";
  }

  .courseGrid>>>table.el-table__body td:nth-of-type(4):before {
    content: "Estimated Time (in min)";
  }

  .courseGrid>>>table.el-table__body td:nth-of-type(5):before {
    content: "Action";
  }

  .assignedGrid>>>table.el-table__body td:nth-of-type(1):before {
    content: "Lesson Name" !important;
  }

  .assignedGrid>>>table.el-table__body td:nth-of-type(2):before {
    content: "Lesson Status";
  }

  .assignedGrid>>>table.el-table__body td:nth-of-type(3):before {
    content: "Completed Date";
  }

  .assignedGrid>>>table.el-table__body td:nth-of-type(4):before {
    content: "Assigned Date";
  }

  .assignedGrid>>>table.el-table__body td:nth-of-type(5):before {
    content: "Due Date";
  }

  .assignedGrid>>>table.el-table__body td:nth-of-type(6):before {
    content: "Action";
  }
}

.home-card-header {
  min-height: 44px;
}

.safedig-envelope-icon {
  margin-left: 8px;
  vertical-align: middle;
}

.fade-leave-active {
  transition: all 0.9s ease;
  overflow: hidden;
  visibility: visible;
  position: absolute;
  width: 100%;
  opacity: 1;
}

.fade-enter,
.fade-leave-to {
  visibility: hidden;
  width: 100%;
  opacity: 0;
}

iframe {
  height: 500px;
  width: 100%;
}

#app iframe {
  width: 100%;
  height: 500px;
}

.courses .card-header {
  padding-bottom: 0px !important;
}

.click-text {
  padding-right: 5px;
  color: #00ccff;
}

.click-text:hover {
  text-decoration: underline;
  color: #0b427b;
}

.dashbaordbox a {
  /* box-shadow: 0px 0px 11px #05b8e4; */
  display: block;
}

.dashbaordbox .icon {
  width: 4rem;
  height: 4rem;
}

.dashbarod-card-title {
  font-size: 15px;
  padding: 5px 0;
}

.dashbarod-table-box .el-table .el-table__header-wrapper thead th .cell {
  min-height: 22px;
  font-weight: 700;
}

.dashbarod-table-box .el-table__body-wrapper table tbody td {
  padding: 3px;
}

.select_new {
  position: absolute;
  bottom: 24px;
  max-width: 200px;
  left: 50px;
}


.el-input.el-input--suffix INPUT {
  HEIGHT: 30PX !IMPORTANT;
}

@media only screen and (max-width: 992px) {
  .select_new {
    position: absolute;
    bottom: 34px;
    max-width: 50%;
    left: 50px;
  }
}

@media only screen and (max-width: 767px) {
  .select_new {
    position: absolute;
    bottom: 34px;
    max-width: 100%;
    left: 50px;
  }
}

.location_FlexBox {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-top: 5px;
  z-index: 999;
  right: 5px;
  bottom: 9px;
  position: absolute;
}

.company-location-dropdown {
  position: static;
  max-width: 100%;
  padding-right: 10px;
}

.dash-card-box {
  /* margin-bottom: 20px; */
}

.select-primary-orange.max-width,
.select-brand.max-width {
  max-width: 146px;
}

.location_FlexBox {
  max-width: auto;
}

.card-left .select_new>>>.el-select .el-input--suffix .el-input__inner {
  white-space: nowrap;
  overflow: hidden;
  -o-text-overflow: ellipsis;
  -ms-text-overflow: ellipsis;
  text-overflow: ellipsis;
  line-height: 30px;
  font-size: 13px;
  padding: 0 20px 0 12px !important;
}


@media only screen and (max-width: 1199px) {
  .location_FlexBox {
    max-width: 100%;
  }

  .card-left .select_new>>>.el-select .el-input--suffix .el-input__inner {
    width: 100%;
    padding-right: 17px;
  }
}

.course-status {
  color: #7C7B7B;
  font-size: 14px;
}

.course-status span:after {
  content: "";
  width: 12px;
  margin-left: 5px;
  height: 12px;
  display: inline-block;
  background: #139A1B;
  border-radius: 50%;
  position: relative;
  top: 1px;
}

.course-status span.active:after {
  background: #139A1B;
}

.course-status span.failed:after {
  background: #FFF600;
}

.course-status span.expired:after {
  background: #E83124;
}

.select-brand .el-input__inner {
  background: var(--brand-primary);
  border-color: var(--brand-primary);
  color: #fff;
  border-radius: 30px;
}
</style>
